exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".blumar-loading[data-v-3f0dc542]{position:fixed;left:48.2%;z-index:9999;bottom:15px;width:3rem;height:3rem;color:#163247!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3f0dc542","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/BlumarLoading.vue
// module id = 816
// module chunks = 0